var utils = {
    deepClone:function(obj){
        let _obj = JSON.stringify(obj),//把JSON对象转化为字符串
        objClone = JSON.parse(_obj);//把JSON字符串转化为对象
        return objClone;
    },
    formatPropData:function(element,val,iUnit=true){
        var type=element.dataType;
        var value='';
        switch(type){
            case "FLOAT":
            case "DOUBLE":
                val = val.toString().replace(/\$|\,/g,'');
                if(isNaN(val)) {
                    val = "0";
                } 
                let sign = (val == (val = Math.abs(val)));
                val = Math.floor(val*100+0.00000000001);
                let cents = val%100;
                val = Math.floor(val/100).toString();
                if(cents<10) {
                    cents = "0" + cents;
                }
                for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
                    val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
                }

                value= (((sign)?'':'-') + val + '.' + cents);
                if(iUnit){
                    value += element.dataSpecs.unit;
                }
                break
            default:
                value= val;
                if(iUnit){
                    value += element.dataSpecs.unit;
                }
                break
        }
        return value;
    },
    formatNumber:function(val,num=2){
        var value=parseFloat(val);
        return parseFloat(value.toFixed(num));
    },
    formatNumber1:function(val){
        var value=Number(val);
        return value;
    },
    getDate(type,val) {   
        const date = new Date();
        if(val != null) {date= new Date(val);}
        if(type==='lastday'){
            date.setDate(date.getDate() - 1);
        }
        else if(type==='nextday'){
            date.setDate(date.getDate() + 1);
        }
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (type === 'start') {
            year = year - 60;
        } else if (type === 'end') {
            year = year + 2;
        }
        
        month = month > 9 ? month : '0' + month;;
        day = day > 9 ? day : '0' + day;
        return `${year}-${month}-${day}`;
    },
    getDateTime(val){
        const date = new Date();
        if(val != null) {date= new Date(val);}
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        let hours =date.getHours();
        let minutes =date.getMinutes();
        let seconds =date.getSeconds();

        month = month > 9 ? month : '0' + month;;
        day = day > 9 ? day : '0' + day;
        hours = hours > 9 ? hours : '0' + hours;
        minutes = minutes > 9 ? minutes : '0' + minutes;
        seconds = seconds > 9 ? seconds : '0' + seconds;
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} `;
    }
}

export default utils